import axios, { AxiosError } from "axios";
import PlanDTO from "../Models/DTOs/Plan";
import {SubscriptionOfferResolution} from "../Models/DTOs/SubscriptionOffer";
import {BillingOfferAudience} from "../Helpers/BillingOffers";

const BACKEND_URL = process.env.REACT_APP_WEB_API_URL ?? "/"; // adjust if needed

export async function GetPlans(
    abortController: AbortController,
): Promise<PlanDTO[] | AxiosError> {
    try {
        const params = new URLSearchParams();
        const url =
            BACKEND_URL +
            "v1/billing/plans" +
            (params.toString() ? `?${params.toString()}` : "");

        const res = await axios.get<PlanDTO[] | { plans: PlanDTO[] }>(url, {
            signal: abortController.signal,
        });

        // Accept either a raw array or { plans: [...] }
        const data = Array.isArray(res.data)
            ? res.data
            : (res.data as { plans: PlanDTO[] }).plans;

        return data;
    } catch (err: unknown) {
        if (axios.isAxiosError(err)) return err;
        return new AxiosError("Non-Axios error", "ERR_UNKNOWN");
    }
}

export async function GetBillingOffers(
    abortController: AbortController,
    audience: BillingOfferAudience,
    promotionCode?: string | null,
): Promise<SubscriptionOfferResolution | AxiosError> {
    try {
        const params = new URLSearchParams({audience});
        if (promotionCode) params.set("promo", promotionCode);

        const res = await axios.get<SubscriptionOfferResolution>(
            `${BACKEND_URL}v1/billing/offers?${params.toString()}`,
            {signal: abortController.signal}
        );
        return res.data;
    } catch (err: unknown) {
        if (axios.isAxiosError(err)) return err;
        return new AxiosError("Non-Axios error", "ERR_UNKNOWN");
    }
}
